export default "__VITE_ASSET__7X$IkhyW__"